import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);
dayjs.extend(timezone);

export const STUDENT_TIME_ZONE = "Asia/Kolkata";

const SOURCE_TIME_ZONES = new Set([
  STUDENT_TIME_ZONE,
  "America/New_York",
  "America/Chicago",
  "America/Denver",
  "America/Phoenix",
  "America/Los_Angeles",
  "America/Anchorage",
  "America/Adak",
  "Pacific/Honolulu",
  "America/Puerto_Rico",
  "Pacific/Pago_Pago",
  "Pacific/Guam",
  "Pacific/Midway",
  "Pacific/Wake",
]);

export const sourceTimeZone = (value?: string | null): string =>
  value && SOURCE_TIME_ZONES.has(value) ? value : STUDENT_TIME_ZONE;

/** Published schedules are instants; older schedules have separate IST date and time fields. */
export function studentScheduleInstant(
  instant?: string | null,
  date?: string | null,
  time?: string | null,
  scheduleZone?: string | null,
): string | null {
  if (instant) return dayjs(instant).isValid() ? dayjs(instant).toISOString() : null;
  if (!date || !time) return null;
  const zone = sourceTimeZone(scheduleZone);
  const calendarDate = date.includes("T")
    ? dayjs(date).tz(zone).format("YYYY-MM-DD")
    : date.slice(0, 10);
  const clock = /^([01]\d|2[0-3]):([0-5]\d)/.exec(time);
  if (!clock) return null;
  const value = dayjs.tz(`${calendarDate}T${clock[1]}:${clock[2]}`, zone);
  return value.isValid() ? value.toISOString() : null;
}

export function formatStudentSchedule(
  instant?: string | null,
  date?: string | null,
  time?: string | null,
  pattern = "MMM DD hh:mm A",
  scheduleZone?: string | null,
): string {
  const value = studentScheduleInstant(instant, date, time, scheduleZone);
  return value ? dayjs(value).tz(STUDENT_TIME_ZONE).format(pattern) : "--";
}

export function studentScheduleWall(
  instant?: string | null,
  date?: string | null,
  time?: string | null,
  scheduleZone?: string | null,
): string | null {
  const value = studentScheduleInstant(instant, date, time, scheduleZone);
  return value ? dayjs(value).tz(STUDENT_TIME_ZONE).format("YYYY-MM-DDTHH:mm:ss") : null;
}
